import { GalleryImage } from 'editor/src/store/gallery/types';

const hasCurrentPrintDetail = (image: Pick<GalleryImage, 'url' | 'printDetail'>) =>
  !!image.printDetail && image.printDetail.url === image.url;

export default hasCurrentPrintDetail;
